import { PAYOUT_DIRECTION_ID } from 'constants/directions';

import { PresetsEditItems } from './PresetsEditItems';

export const PresetsEditPayoutItems: React.FC = () => (
  <PresetsEditItems
    apiKey="payout_items"
    directionId={PAYOUT_DIRECTION_ID}
    itemsField="payoutItems"
    successText="Пресеты вывода успешно изменены"
    title="Редактирование пресетов выводов"
  />
);
